import React from 'react';
import { StyleSheet, Text, View, Image } from 'react-native';

import IMAGES from 'shared/constants/images';
import Button from 'shared/modules/common/components/atoms/Button';

type Props = {
  /*
  To invoke when clicked
   */
  onNextButtonPress: () => void;
};

const EditUserEmailSuccess = (props: Props) => {
  return (
    <View style={style.root}>
      <View style={style.topContainer}>
        <Image
          source={{ uri: IMAGES.success }}
          style={{ width: 184, height: 184 }}
        />
        <Text
          style={style.textTitle}
        >{`メールアドレスの変更が\n完了しました`}</Text>
      </View>

      <Button
        title="次へ"
        onPress={props.onNextButtonPress}
        id="edit-user-email-next-button"
        style={style.button}
      />
    </View>
  );
};

const style = StyleSheet.create({
  root: {
    flexGrow: 1,
    justifyContent: 'space-between',
  },
  topContainer: {
    alignItems: 'center',
  },
  textTitle: {
    fontSize: 20,
    fontWeight: '600',
    textAlign: 'center',
    lineHeight: 24,
  },
  button: {
    alignSelf: 'center',
  },
});

export default EditUserEmailSuccess;
